import { normalize } from 'normalizr';

import api from '../../api';
import { schema } from '../../schema';
import { addEntities, removeEntity } from '../../actions';
import Logger from '../../../lib/Logger';

// ACTION TYPES

export const TYPES = {
  COGNITO_FORM_ADMIN_LIST_REQUEST: 'COGNITO_FORM_ADMIN/LIST_REQUEST',
  COGNITO_FORM_ADMIN_LIST_SUCCESS: 'COGNITO_FORM_ADMIN/LIST_SUCCESS',
  COGNITO_FORM_ADMIN_LIST_FAILURE: 'COGNITO_FORM_ADMIN/LIST_FAILURE',
  COGNITO_FORM_ADMIN_READ_REQUEST: 'COGNITO_FORM_ADMIN/READ_REQUEST',
  COGNITO_FORM_ADMIN_READ_SUCCESS: 'COGNITO_FORM_ADMIN/READ_SUCCESS',
  COGNITO_FORM_ADMIN_READ_FAILURE: 'COGNITO_FORM_ADMIN/READ_FAILURE',
  COGNITO_FORM_ADMIN_UPDATE_REQUEST: 'COGNITO_FORM_ADMIN/UPDATE_REQUEST',
  COGNITO_FORM_ADMIN_UPDATE_SUCCESS: 'COGNITO_FORM_ADMIN/UPDATE_SUCCESS',
  COGNITO_FORM_ADMIN_UPDATE_FAILURE: 'COGNITO_FORM_ADMIN/UPDATE_FAILURE',
  COGNITO_FORM_ADMIN_CREATE_REQUEST: 'COGNITO_FORM_ADMIN/CREATE_REQUEST',
  COGNITO_FORM_ADMIN_CREATE_SUCCESS: 'COGNITO_FORM_ADMIN/CREATE_SUCCESS',
  COGNITO_FORM_ADMIN_CREATE_FAILURE: 'COGNITO_FORM_ADMIN/CREATE_FAILURE',
  COGNITO_FORM_ADMIN_DELETE_REQUEST: 'COGNITO_FORM_ADMIN/DELETE_REQUEST',
  COGNITO_FORM_ADMIN_DELETE_SUCCESS: 'COGNITO_FORM_ADMIN/DELETE_SUCCESS',
  COGNITO_FORM_ADMIN_DELETE_FAILURE: 'COGNITO_FORM_ADMIN/DELETE_FAILURE',
  COGNITO_FORM_ADMIN_FORM_DESTROY: 'COGNITO_FORM_ADMIN/FORM_DESTROY',
  COGNITO_FORM_ADMIN_PATCH_REQUEST: 'COGNITO_FORM_ADMIN/PATCH_REQUEST',
  COGNITO_FORM_ADMIN_PATCH_SUCCESS: 'COGNITO_FORM_ADMIN/PATCH_SUCCESS',
  COGNITO_FORM_ADMIN_PATCH_FAILURE: 'COGNITO_FORM_ADMIN/PATCH_FAILURE',
  COGNITO_FORM_ADMIN_SHOW_FORM: 'COGNITO_FORM_ADMIN/SHOW_FORM',
  COGNITO_FORM_ADMIN_HIDE_FORM: 'COGNITO_FORM_ADMIN/HIDE_FORM',
};
// ACTION CREATORS

export function cognitoFormAdminFormDestroy(formState = null) {
  Logger.log(
    'debug',
    `[state.cognitoFormsAdmin.actions] cognitoFormAdminFormDestroy(%j)`,
    formState
  );
  return {
    type: TYPES.COGNITO_FORM_ADMIN_FORM_DESTROY,
    form: formState,
  };
}

export function cognitoFormAdminShowForm(id = null) {
  Logger.log(
    'debug',
    `[state.cognitoFormsAdmin.actions] cognitoFormAdminFormDestroy(${id})`
  );
  return {
    type: TYPES.COGNITO_FORM_ADMIN_SHOW_FORM,
    id: id,
  };
}

export function cognitoFormAdminHideForm() {
  Logger.log(
    'debug',
    `[state.cognitoFormsAdmin.actions] cognitoFormAdminFormDestroy()`
  );
  return {
    type: TYPES.COGNITO_FORM_ADMIN_HIDE_FORM,
  };
}

export function cognitoFormAdminListRequest(page, limit, order, filter) {
  Logger.log(
    'debug',
    `[state.cognitoFormsAdmin.actions] cognitoFormAdminListRequest(${page}, ${limit}, ${order}, %j)`,
    filter
  );
  return {
    type: TYPES.COGNITO_FORM_ADMIN_LIST_REQUEST,
    page: page,
    limit: limit,
    order: order,
    filter: filter,
  };
}

export function cognitoFormAdminListSuccess(data) {
  Logger.log(
    'debug',
    `[state.cognitoFormsAdmin.actions] cognitoFormAdminListSuccess(%j)`,
    data
  );
  return {
    type: TYPES.COGNITO_FORM_ADMIN_LIST_SUCCESS,
    page: data.page,
    limit: data.limit,
    order: data.order,
    result: data.result,
    total: data.total,
    receivedAt: Date.now(),
  };
}

export function cognitoFormAdminListFailure(error) {
  Logger.log(
    'debug',
    `[state.cognitoFormsAdmin.actions] cognitoFormAdminListFailure(%j)`,
    error
  );
  return {
    type: TYPES.COGNITO_FORM_ADMIN_LIST_FAILURE,
    error: error,
  };
}

export function cognitoFormReadAdminRequest(id) {
  Logger.log(
    'debug',
    `[state.cognitoFormsAdmin.actions] cognitoFormReadAdminRequest(${id})`
  );
  return {
    type: TYPES.COGNITO_FORM_ADMIN_READ_REQUEST,
    id: id,
  };
}

export function cognitoFormReadAdminSuccess(data) {
  Logger.log(
    'debug',
    `[state.cognitoFormsAdmin.actions] cognitoFormReadAdminSuccess(%j)`,
    data
  );
  return {
    type: TYPES.COGNITO_FORM_ADMIN_READ_SUCCESS,
    id: data.id,
    receivedAt: Date.now(),
  };
}

export function cognitoFormReadAdminFailure(error) {
  Logger.log(
    'debug',
    `[state.cognitoFormsAdmin.actions] cognitoFormReadAdminFailure(%j)`,
    error
  );
  return {
    type: TYPES.COGNITO_FORM_ADMIN_READ_FAILURE,
    error: error,
  };
}

export function cognitoFormAdminUpdateRequest(id, data) {
  Logger.log(
    'debug',
    `[state.cognitoFormsAdmin.actions] cognitoFormAdminUpdateRequest(${id}, %j)`,
    data
  );
  return {
    type: TYPES.COGNITO_FORM_ADMIN_UPDATE_REQUEST,
  };
}

export function cognitoFormAdminUpdateSuccess(data) {
  Logger.log(
    'debug',
    `[state.cognitoFormsAdmin.actions] cognitoFormAdminUpdateSuccess(%j)`,
    data
  );
  return {
    type: TYPES.COGNITO_FORM_ADMIN_UPDATE_SUCCESS,
    id: data.id,
    receivedAt: Date.now(),
  };
}

export function cognitoFormAdminUpdateFailure(error) {
  Logger.log(
    'debug',
    `[state.cognitoFormsAdmin.actions] cognitoFormAdminUpdateFailure(%j)`,
    error
  );
  return {
    type: TYPES.COGNITO_FORM_ADMIN_UPDATE_FAILURE,
    error: error,
  };
}

export function cognitoFormAdminCreateRequest(data) {
  Logger.log(
    'debug',
    `[state.cognitoFormsAdmin.actions] cognitoFormAdminCreateRequest(%j)`,
    data
  );
  return {
    type: TYPES.COGNITO_FORM_ADMIN_CREATE_REQUEST,
  };
}

export function cognitoFormAdminCreateSuccess(data) {
  Logger.log(
    'debug',
    `[state.cognitoFormsAdmin.actions] cognitoFormAdminCreateSuccess(%j)`,
    data
  );
  return {
    type: TYPES.COGNITO_FORM_ADMIN_CREATE_SUCCESS,
    id: data.id,
    receivedAt: Date.now(),
  };
}

export function cognitoFormAdminCreateFailure(error) {
  Logger.log(
    'debug',
    `[state.cognitoFormsAdmin.actions] cognitoFormAdminCreateFailure(%j)`,
    error
  );
  return {
    type: TYPES.COGNITO_FORM_ADMIN_CREATE_FAILURE,
    error: error,
  };
}

export function cognitoFormAdminDeleteRequest(id) {
  Logger.log(
    'debug',
    `[state.cognitoFormsAdmin.actions] cognitoFormAdminDeleteRequest(${id})`
  );
  return {
    type: TYPES.COGNITO_FORM_ADMIN_DELETE_REQUEST,
    id: id,
  };
}

export function cognitoFormAdminDeleteSuccess(id) {
  Logger.log(
    'debug',
    `[state.cognitoFormsAdmin.actions] cognitoFormAdminDeleteSuccess(${id})`
  );
  return {
    type: TYPES.COGNITO_FORM_ADMIN_DELETE_SUCCESS,
    id: id,
  };
}

export function cognitoFormAdminDeleteFailure(error) {
  Logger.log(
    'debug',
    `[state.cognitoFormsAdmin.actions] cognitoFormAdminDeleteFailure(%j)`,
    error
  );
  return {
    type: TYPES.COGNITO_FORM_ADMIN_DELETE_FAILURE,
    error: error,
  };
}

export function cognitoFormAdminPatchRequest(partnershipId, id, data) {
  Logger.log(
    'debug',
    `[state.cognitoFormsAdmin.actions] cognitoFormAdminPatchRequest(${partnershipId}, ${id}, %j)`,
    data
  );
  return {
    type: TYPES.COGNITO_FORM_ADMIN_PATCH_REQUEST,
    partnershipId: partnershipId,
  };
}

export function cognitoFormAdminPatchSuccess(partnershipId, data) {
  Logger.log(
    'debug',
    `[state.cognitoFormsAdmin.actions] cognitoFormAdminPatchSuccess(${partnershipId}, %j)`,
    data
  );
  return {
    type: TYPES.COGNITO_FORM_ADMIN_PATCH_SUCCESS,
    id: data.id,
    partnershipId: partnershipId,
    receivedAt: Date.now(),
  };
}

export function cognitoFormAdminPatchFailure(partnershipId, error) {
  Logger.log(
    'debug',
    `[state.cognitoFormsAdmin.actions] cognitoFormAdminPatchFailure(%j)`,
    error
  );
  return {
    type: TYPES.COGNITO_FORM_ADMIN_PATCH_FAILURE,
    partnershipId: partnershipId,
    error: error,
  };
}

// API THUNK ACTION CREATORS

export function loadCognitoFormsAdmin(
  parntership_id = null,
  page = 1,
  limit = 10,
  order = null,
  filter = null,
  cb = function () {}
) {
  Logger.log(
    'debug',
    `[state.cognitoFormsAdmin.actions] loadCognitoFormsAdmin(${page}, ${limit}, ${order}, %j, ###)`,
    filter
  );

  return async function (dispatch) {
    dispatch(cognitoFormAdminListRequest(page, limit, order, filter));

    // call API
    const response = await api.getCognitoFormsAdmin(
      parntership_id,
      page,
      limit,
      order,
      filter
    );
    let success = false;

    // get cognito forms admin list success
    if (200 === response.get('status')) {
      Logger.log(
        'info',
        `Get API cognito forms admin list success. Page: ${page}, Limit: ${limit}, Order: ${order}.`
      );

      const normalizedEntities = normalize(
        response.getIn(['data', 'cognito_forms']),
        [schema.cognitoFormAdmin]
      );
      const data = {
        page: response.getIn(['data', 'page']),
        limit: response.getIn(['data', 'limit']),
        order: order,
        total: response.getIn(['data', 'total']),
        result: normalizedEntities.result,
      };

      dispatch(addEntities(normalizedEntities));
      dispatch(cognitoFormAdminListSuccess(data));
      success = true;
    } else if (1 === page && 204 === response.get('status')) {
      Logger.log(
        'info',
        `Get API cognito forms admin success [empty]. Page: ${page}, Limit: ${limit}, Order: ${order}.`
      );
      const data = {
        page: page,
        limit: limit,
        order: order,
        total: 0,
        result: [],
      };
      dispatch(cognitoFormAdminListSuccess(data));
      success = true;

      // get cognito forms admin list failure
    } else {
      Logger.log(
        'info',
        `Get API cognito forms admin list failure. Page: ${page}, Limit: ${limit}, Order: ${order}.`
      );
      dispatch(cognitoFormAdminListFailure(response.getIn(['data', 'error'])));
    }

    // callback function
    cb(success);
  };
}

export function loadCognitoFormAdmin(partnership_id, id, cb = function () {}) {
  Logger.log(
    'debug',
    `[state.cognitoFormsAdmin.actions] loadCognitoFormAdmin(${id}, ###)`
  );

  return async function (dispatch) {
    dispatch(cognitoFormReadAdminRequest(id));

    // call API
    const response = await api.getCognitoFormAdmin(partnership_id, id);
    let success = false;

    // get cognito form admin success
    if (200 === response.get('status')) {
      Logger.log('info', `Get API cognito form admin success. ID: ${id}.`);

      const normalizedEntities = normalize(
        [response.getIn(['data', 'cognito_form'])],
        [schema.cognitoFormAdmin]
      );
      const data = {
        id: response.getIn(['data', 'cognito_form', 'id']),
      };

      dispatch(addEntities(normalizedEntities));
      dispatch(cognitoFormReadAdminSuccess(data));
      success = true;

      // get cognito form admin failure
    } else {
      Logger.log('info', `Get API cognito form admin failure. ID: ${id}.`);
      dispatch(cognitoFormReadAdminFailure(response.getIn(['data', 'error'])));
    }

    // callback function
    cb(success);
  };
}

export function updateCognitoFormAdmin(id, data, cb = function () {}) {
  Logger.log(
    'debug',
    `[state.cognitoFormsAdmin.actions] updateCognitoFormAdmin(${id}, %j, ###)`,
    data
  );

  return async function (dispatch) {
    dispatch(cognitoFormAdminUpdateRequest(id, data));

    // call API
    const response = await api.putCognitoFormAdmin(id, data);
    let success = false;

    // put cognito form admin success
    if (200 === response.get('status')) {
      Logger.log('info', `PUT API cognito form admin success. User: ${id}.`);

      const normalizedEntities = normalize(
        [response.getIn(['data', 'cognito_form'])],
        [schema.cognitoFormAdmin]
      );
      const data = {
        id: response.getIn(['data', 'cognito_form', 'id']),
      };

      dispatch(addEntities(normalizedEntities));
      dispatch(cognitoFormAdminUpdateSuccess(data));
      success = true;

      // get cognito form admin failure
    } else {
      Logger.log('info', `PUT API cognito form admin failure. ID: ${id}.`);
      dispatch(
        cognitoFormAdminUpdateFailure(response.getIn(['data', 'error']))
      );
    }

    // callback function
    cb(success);
  };
}

export function createCognitoFormAdmin(data, cb = function () {}) {
  Logger.log(
    'debug',
    `[state.cognitoFormsAdmin.actions] createCognitoFormAdmin(%j, ###)`,
    data
  );

  return async function (dispatch) {
    dispatch(cognitoFormAdminCreateRequest(data));

    // call API
    const response = await api.postCognitoFormAdmin(data);
    let success = false;

    // post journal partenr tag admin success
    if (201 === response.get('status')) {
      Logger.log(
        'info',
        `POST API cognito forms admin success. Post: ${response.getIn([
          'data',
          'cognito_form',
          'id',
        ])}.`
      );

      const normalizedEntities = normalize(
        [response.getIn(['data', 'cognito_form'])],
        [schema.cognitoFormAdmin]
      );
      const data = {
        id: response.getIn(['data', 'cognito_form', 'id']),
      };

      dispatch(addEntities(normalizedEntities));
      dispatch(cognitoFormAdminCreateSuccess(data));
      success = true;

      // get cognito forms admin failure
    } else {
      Logger.log('info', `POST API cognito forms admin failure.`);
      dispatch(
        cognitoFormAdminCreateFailure(response.getIn(['data', 'error']))
      );
    }

    // callback function
    cb(success);
  };
}

export function deleteCognitoFormAdmin(
  partnership_id,
  id,
  cb = function () {}
) {
  Logger.log(
    'debug',
    `[state.cognitoFormsAdmin.actions] deleteCognitoFormAdmin(${id}, ###)`
  );

  return async function (dispatch) {
    dispatch(cognitoFormAdminDeleteRequest(id));

    // call API
    const response = await api.deleteCognitoFormAdmin(partnership_id, id);
    let success = false;

    // delete cognito form admin success
    if (204 === response.get('status')) {
      Logger.log('info', `DELETE API cognito form admin success. ID: ${id}.`);

      dispatch(
        removeEntity({
          entityType: 'cognitoFormsAdmin',
          id: id,
        })
      );
      dispatch(cognitoFormAdminDeleteSuccess(id));
      success = true;

      // get cognito form admin failure
    } else {
      Logger.log('info', `DELETE API cognito form admin failure. ID: ${id}.`);
      dispatch(
        cognitoFormAdminDeleteFailure(response.getIn(['data', 'error']))
      );
    }

    // callback function
    cb(success);
  };
}

export function patchCognitoFormAdmin(
  partnershipId = null,
  id,
  data,
  cb = function () {}
) {
  Logger.log(
    'debug',
    `[state.cognitoFormsAdmin.actions] patchCognitoFormAdmin(${partnershipId}, ${id}, %j, ###)`,
    data
  );

  return async function (dispatch) {
    dispatch(cognitoFormAdminPatchRequest(partnershipId, id, data));

    // call API
    const response = await api.patchCognitoFormAdmin(partnershipId, id, data);
    let success = false;

    // put cognito form admin success
    if (200 === response.get('status')) {
      Logger.log('info', `PUT API cognito form admin success. User: ${id}.`);

      const normalizedEntities = normalize(
        [response.getIn(['data', 'cognito_form'])],
        [schema.cognitoFormAdmin]
      );
      const data = {
        id: response.getIn(['data', 'cognito_form', 'id']),
      };

      dispatch(addEntities(normalizedEntities));
      dispatch(cognitoFormAdminPatchSuccess(partnershipId, data));
      success = true;

      // get cognito form admin failure
    } else {
      Logger.log('info', `PUT API cognito form admin failure. ID: ${id}.`);
      dispatch(
        cognitoFormAdminPatchFailure(
          partnershipId,
          response.getIn(['data', 'error'])
        )
      );
    }

    // callback function
    cb(success);
  };
}

Logger.log('silly', `cognitoFormsAdmin.actions loaded.`);
